import React, { Fragment, useState } from 'react';
import Modal from 'react-modal';
import Input from '../../TravellerContactInfo/FormFields/Input';
import '../LoginModals.css';
import { useForgotPasswordContainer } from './ForgotPasswordContainer';
import { UserFlowModalState } from "../../UserFlow/UserFlowModal";

const newPasswordOptions = [
  {
    label: "On Mobile",
    name: "newPasswordOn",
    id: "passwordOnMobile",
    value: "M",
    isDefault: true,
  },
  {
    label: "On Email Id",
    name: "newPasswordOn",
    id: "passwordOnEmail",
    value: "E",
    isDefault: false,
  }
];

const DEFAULT_NEW_PASSWORD_OPTION = "M";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const getErrorMessage = (otpType: string, errorMessage: string) => {
  if (errorMessage) {
    return errorMessage;
  };
  if (otpType === "M") {
    return "This mobile number and username are not linked.";
  }
  if (otpType === "E") {
    return "This email id and username are not linked.";
  }
}

const ForgotPassword = (props: UserFlowModalState) => {

  const [state, setState] = useState({
    newPasswordOn: DEFAULT_NEW_PASSWORD_OPTION,
    value: '',
  });

  const {
    state: {
      showModal,
      userStatus,
      rotate,
      validationFail,
      disabled,
      validationErrorMessage,
    },

    action: {
      rotateLoader,
      handleInputKeyUpViaParent,
      closeModal,
      clearValidationError
    },
  } = useForgotPasswordContainer(props);

  const updateNewPasswordOnOption = (e) => {
    setState({
      ...state,
      value: '',
      newPasswordOn: e.target.value,
    });
    clearValidationError();
  }

  const handleTextChange = (value) => {
    const { newPasswordOn } = state;
    if (newPasswordOn === "M") {
      setState({
        ...state,
        value
      })
    } else {
      setState({
        ...state,
        value
      });
    }
    handleInputKeyUpViaParent(value, newPasswordOn);
  }

  const { userId } = userStatus;
  const { newPasswordOn, value } = state;
  return (
    <Fragment>
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        onRequestClose={closeModal}
        className='loginModals loginModals--v3 resetPass'
        id="mmt-irctc-reset-pass"
        style={{
          overlay: {
            backgroundColor: 'rgb(0, 0, 0, 0.6)',
            zIndex: 1,
          },
          customStyles,
        }}
      >
        <p className='makeFlex spaceBetween appendBottom10'>
          <span className='modalTitle font26 latoBlack blackText'>
              Reset IRCTC Password
          </span>
          <span
            className='modalClose railSprite crossIcon'
            onClick={closeModal}>
          </span>
        </p>
        <p className='additionalInfo appendBottom20 font14'>
            Enter the mobile number or email id registered with
          <span className="blackText"> IRCTC username {userId} </span>
            to get a new password.
        </p>
        <p className="blackText appendBottom10 latoBlack">
          Get new password on
        </p>

        <div className="newPasswordOptions checkboxWrapper appendBottom20">
          {
            newPasswordOptions.map(option => {
              return (
                <div key={option.id} className="radioBox">
                  <input
                    type="radio"
                    name={option.name}
                    id={option.id}
                    value={option.value}
                    onChange={updateNewPasswordOnOption}
                    defaultChecked={option.isDefault}
                  />
                  <label
                    className="font14 darkGreyText"
                    htmlFor={option.id}
                  >
                    { option.label }
                  </label>
                </div>
              )
            })
          }
        </div>
        <div className={'makeFlex column spaceBetween'}>
          {
            newPasswordOn === "M"
            ? <Input
              labelName="Mobile Number"
              errorMessage={getErrorMessage("M", validationErrorMessage)}
              validationFail={validationFail}
              type="number"
              additionalAttributes={{ placeholder: 'Enter Mobile Number' }}
              fieldId="IRCTCUserNumber"
              fieldName="IRCTCUserNumber"
              vaidationMsg=""
              vaidationMoreMsg={null}
              vaidationMoreStatus={false}
              vaidationStatus={true}
              readOnly={false}
              style={'darkGreyText capText labelName greyed'}
              handleInputKeyUpViaParent={handleTextChange}
              value={value}
            />
            : <Input
              value={value}
              labelName="Email ID"
              errorMessage={getErrorMessage("E", validationErrorMessage)}
              validationFail={validationFail}
              type="text"
              additionalAttributes={{ placeholder: 'Enter your email id' }}
              fieldId="IRCTCUserEmail"
              fieldName="IRCTCUserEmail"
              vaidationMsg=""
              vaidationMoreMsg={null}
              vaidationMoreStatus={false}
              vaidationStatus={true}
              readOnly={false}
              style={'darkGreyText capText labelName greyed'}
              handleInputKeyUpViaParent={handleTextChange}
            />
          }

          {/*{error && <p className="appendTop5 redText font14">{error}</p>}*/}
        </div>
        <button
          onClick={rotateLoader}
          style={{ width: '186px', marginTop: '20px' ,maxHeight:'35px'}}
          className={`${disabled ? 'disabled' : ''} noShrink`}>
          <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack capText'}`}>
              Get Password on { newPasswordOn === "M" ? "SMS" : "Email"}
          </span>
        </button>
      </Modal>
    </Fragment>
  );
};

export default ForgotPassword;
